import $ from 'jquery'
import 'slick-carousel'

function ready() {
  $('.therapist-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0px',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '0px'
        }
      }
    ]
  });

  // Fix overflow
  $('.therapist-slider, .therapist-slider .slick-track').css('overflow', 'visible');

  // Espacio arriba de las fotos
  $('.therapist-slider .slick-slide img').css('margin-top', '40px');

  $('.therapist-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $('.therapist-slider .slick-slide').css({
      'transform': 'scale(1)',
      'transition': 'transform 0.3s ease',
      'z-index': '1',
      'position': 'relative'
    });
  });

  $('.therapist-slider').on('afterChange', function(event, slick, currentSlide) {
    $('.therapist-slider .slick-center').css({
      'transform': 'scale(1.5)',
      'transition': 'transform 0.3s ease',
      'z-index': '100',
      'position': 'relative'
    });
  });

  // Activar el centro al inicio
  $('.therapist-slider .slick-center').css({
    'transform': 'scale(1.5)',
    'z-index': '100',
    'position': 'relative'
  });
}

$(document).on('turbolinks:load', ready);